import { createContext } from "react";

const ScheludeContext = createContext({
    positionLeft: 0,
    setPositionLeft: (auth) => {}
});
export default ScheludeContext;